import React, { useContext } from "react";
import _ from "lodash";
import Picker from "../../forms/Picker";
import DataGridContext, { useGridData } from "../GridDataContext";

function splitAtLastDot(inputString) {
  const lastDotIndex = inputString.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return [inputString];  // If no dot is found, return the entire string in an array
  }
  const firstPart = inputString.slice(0, lastDotIndex);
  const secondPart = inputString.slice(lastDotIndex + 1);
  return [firstPart, secondPart];
}



/**
 * Edit picker cell component
 * @module
 * @param {func} parentProps - Parent props contains data
 * @param {func} itemChange - Item Change function
 * @param {func} getColumns - Get columns function
 */
export const editPickerCell = ({ getColumns, withMeta, isValueChanged }) => {
  const PickerCell = (props) => {
    const { dataItem, onChange: onChangeItem, field, tdProps, isInEdit } = props;
    const [_field, _textField] = splitAtLastDot(field);
    const dataValue = _.get(dataItem, _field);
    const parentProps = useContext(DataGridContext);


    const handleChange = (name, selected) => {
      onChangeItem({
        dataItem: dataItem,
        field: name,
        syntheticEvent: new Event("change"),
        value: selected,
      });
    };

    const getValue = (dataValue, column) => {
      if (!dataValue) return "";
      let valueField = column.valueField;
      let toReplace = valueField?.match(/{([^}]+)}/g);
      if (toReplace) {
        toReplace.forEach((element) => {
          let propName = element.replace(/[{}]/g, "");
          const replaceWith = propName.indexOf(".") > -1 ? _.get(dataItem, `${column.field}.${propName}`) : _.get(dataValue, propName);
          valueField = valueField.replace(element, replaceWith != null ? replaceWith : "");
        });
        return valueField;
      } else {
        return _.get(dataValue, _textField);
      }
    };

    const x = getColumns().find((item) => (item.field + "." + item.textField) === field);

    const data = useGridData(`${x?.identif}`);
    const onChange = useGridData(`${x?.onChange}`);
    const onSubmit = useGridData(`${x?.onSubmit}`);

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? (
        <Picker
          textField={x.textField}
          valueField={x.valueField || x.textField}
          onChange={onChange}
          onSubmit={onSubmit}
          data={data ? data.data : []}
          isLoading={data ? data.isLoading : false}
          onSelect={handleChange}
          selected={dataValue}
          schema={x.schema}
          total={data ? data.total : 0}
          disabled={x.disabled}
          name={x.field}
          primaryField={x.primaryField}
          identif={x.identif}
          title={x.title}
          fixedFilter={x.fixedFilter}
          required={x.required}
          placeholder={"Zvoľte hodnotu"}
          currentDataItem={dataItem}
          withMeta={withMeta}
          parentProps={parentProps}
        />
      ) : (
        x ? getValue(dataValue ?? "", x) : null
      )}
    </td>
  }

  return PickerCell;
}
